import { render } from "./support_ticket.vue?vue&type=template&id=c00a87c2"
import script from "./support_ticket.vue?vue&type=script&lang=js"
export * from "./support_ticket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__